<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-divide class="table-tools">
      <div></div>
      <n-link v-if="edit.records" :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td rowspan="3">Дата (число, месяц, год),смена</td>
          <td rowspan="3">Наименование работ и применяемых материалов (пооперационно)</td>
          <td rowspan="3">Объём работ</td>
          <td colspan="2">Температура во время выполнения работ, С</td>
          <td colspan="3">Применяемые материалы</td>
          <td rowspan="3">Число нанесённых слоёв и их толщина, мм</td>
          <td rowspan="3">Температура, С, и продолжительность сушки отдельных слоёв покрытия</td>
          <td rowspan="3">Фамилия и инициалы бригадира (специалиста), выполнявшего защитное покрытие</td>
          <td rowspan="3">Дата и номер акта освидетельствования выполненных работ</td>
          <td rowspan="3">Примечание</td>
          <td rowspan="3">Подпись</td>
          <td></td>
        </tr>
        <tr class="header">
          <td rowspan="2">на поверхности материала</td>
          <td rowspan="2">окружающего воздуха на расстоянии не более 1 м от поверхности</td>
          <td rowspan="2">ГОСТ, ОСТ, ТУ</td>
          <td colspan="2">номер</td>
          <td rowspan="2"></td>
        </tr>
        <tr class="header">
          <td>паспорта</td>
          <td>анализа</td>
        </tr>
        <tr class="header">
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td>8</td>
          <td>9</td>
          <td>10</td>
          <td>11</td>
          <td>12</td>
          <td>13</td>
          <td></td>
        </tr>
      </template>
      <template #date="{item}">
        {{ $app.date.format(item.publishedAt) +' '+ item.date }}
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
      <template #recordsSign="{item}">
        <c-journal-sign :sign="getSign(item, 'records')" />
      </template>
    </n-table>

    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreate from './Create'
import ModalRecord from './record/Index'
import utils from 'utils'
import CJournalSign from '../../../components/journal/Sign'

export default {
  name: 'MainChapter4',
  components: { ModalRecord, PageRecordCreate, CJournalSign, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [
    ],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    edit() {
      return {
        records: $app.auth.can('journals_'+this.journal.name+'_records', this.project.id),
      }
    },
    columns() {
      return [
        { name: 'date', title: '', },
        { name: 'title', title: '', },
        { name: 'workValue', title: '', },
        { name: 'tempTop', title: '', },
        { name: 'tempAir', title: '', },
        { name: 'materialGost', title: '', },
        { name: 'passportNumber', title: '', },
        { name: 'analyzeNumber', title: '', },
        { name: 'layers', title: '', },
        { name: 'tempLayer', title: '', },
        { name: 'foreman', title: '', },
        { name: 'dateAkt', title: '', },
        { name: 'remark', title: '', },
        { name: 'recordsSign', title: '', },
        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load() 
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name)
        .query({
          'with[records][with][participation]': null,
          'with[signs][with][author]': null,
          projectId: this.project.id,
        })
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
